<template>
  <page-wrap>
    <layout :isEmpty="false" class="layout-customer-po-follow-up">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
        <el-tooltip :content="activityTooltip" placement="top">
          <el-switch
            class="layout-customer-po-follow-up__controls"
            v-model="displayActivityLog"
            inactive-color="#ff4949"
            active-color="#13ce66"
            :active-value="true"
            :inactive-value="false">
          </el-switch>
        </el-tooltip>
        <export-excel @onCurrent="onExportCurrent" @onAll="onExportAll" />
      </template>
      <template v-slot:tools>
        <top-panel
          :order-by.sync="orderBy"
        />
      </template>
      <template v-slot:content>
        <editor
          :order-by="orderBy"
          :displayActivityLog="displayActivityLog"
        />
      </template>
    </layout>
  </page-wrap>
</template>

<script>

export default {
  name: 'CustomerPoFollowup',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'top-panel': () => import(/* webpackChunkName: 'CustomerPoFollowup' */ './TopPanel.vue'),
    'editor': () => import(/* webpackChunkName: 'CustomerPoFollowup' */ './Editor.vue'),
    'export-excel': () => import(/* webpackChunkName: 'ExportExcel' */ '@/components/Shared/ExportExcel')
  },
  data () {
    return {
      displayActivityLog: true,
      orderBy: 1
    }
  },
  computed: {
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    },
    activityTooltip () {
      return this.displayActivityLog ? this.L10n('hide-activities-log') : this.L10n('display-activities-log')
    }
  },
  methods: {
    onExportCurrent () {
      this.$bus.$emit('customer-po-followup-on-export', { isAll: false })
    },
    onExportAll () {
      this.$bus.$emit('customer-po-followup-on-export', { isAll: true })
    }
  }
}
</script>
<style lang="stylus">
.layout-customer-po-follow-up {
  .layout__header {
    display flex
    align-items center
    justify-content space-between
    padding-bottom 1rem
  }
  &__controls {
    margin-left auto
    margin-right 1rem
  }
}
</style>
